import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import axios, { baseUrl } from '../../../../redux/my-axios';
import Filter from './filter/Filter';
import List from './list/List';
import Total from './total/Total';

export const URL = '/finance';
const initialFilter = {
  filter: {
    from: '', //Date.now(),
    to: '', //"",
    searchText: '',
  },
  sortOrder: 'desc', // asc||desc
  sortField: 'code',
  pageNumber: 1,
  pageSize: 400,
};
export const FinancePurchasePage = (props) => {
  const [queryParams, setQueryParams] = useState(initialFilter);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [entities, setEntities] = useState([]);
  const [total, setTotal] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    axios
      .post(URL, queryParams, { headers: { action: 'getorders' } })
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log('Result ', response.data.data);
            setTotalCount(response.data.data.totalCount);
            setEntities(response.data.data.list);
            buildTotal(response.data.data.list);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            break;
        }
      })
      .catch((error) => {
        setError(error);
      });
    return () => {
      setEntities([]);
    };
  }, [queryParams]);

  const buildTotal = (entities) => {
    var sumOrders = 0.0;
    var sumReward = 0.0;
    var sumCard = 0.0;

    for (let i = 0; i < entities.length; i++) {
      if (entities[i].orderAmount)
        sumOrders += parseFloat(entities[i].orderAmount);
      if (entities[i].rewardAmount)
        sumReward += parseFloat(entities[i].rewardAmount);
      if (entities[i].cardAmount) sumCard += parseFloat(entities[i].cardAmount);
    }
    setTotal([
      {
        orderAmount: sumOrders,
        rewardAmount: sumReward,
        cardAmount: sumCard,
      },
    ]);
  };

  return (
    <Card id='financePurchaseCard'>
      <CardHeader title='САНХҮҮ: Худалдан авалт'></CardHeader>
      <CardBody>
        <Filter queryParams={queryParams} setQueryParams={setQueryParams} />
        <h6>Нийт дүн</h6>
        <Total
          entities={total}
          totalCount={totalCount}
          setQueryParams={setQueryParams}
        />
        <b>Өдөр бүрийн дүн</b>
        <List
          entities={entities}
          totalCount={totalCount}
          setQueryParams={setQueryParams}
        />
      </CardBody>
    </Card>
  );
};
